import { Component, OnInit, OnDestroy } from '@angular/core';
import { ColumnDef, PageNotes, TableHeader } from '../../global/interfaces';
import { Chart } from '../../shared/charts/charts.class';
import { AppState } from '../../reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  selectPortfolioValuation,
  selectPortfolioValuationDate,
  selectPortfolioValuationValue,
  selectInvestmentGrowthDate,
  selectInvestmentGrowthData,
  selectInvestmentGrowth,
  selectAssetAllocationDate,
  selectAssetAllocationData,
  selectPerformanceValuationAvailability,
  selectPerformanceValuationDate,
  selectPerformanceValuationData,
  selectOverviewLoading,
  selectPerformanceValuationFunds,
  selectPerformanceValuationHoldingDate,
  selectMicData
} from './overview.selectors';
import { map, filter, withLatestFrom, take, distinctUntilChanged, tap } from 'rxjs/operators';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { formatDate } from '../../global/utilities.service';
import { getCurrencyByCountry } from '../../global/languages';
import {
  selectMainFilterSelectedClient,
  selectMainFilterSelectedAccount,
  selectMainPageNotes,
  selectCountrySelected
} from '../../shared/layout/main.selectors';
import { Subscription } from 'rxjs';
import { LoadWidgetsDataAction, ResetWidgetsDataAction } from './overview.actions';
import * as moment from 'moment';
import { RGB_COLORS } from '../../global/colors';
import { AllocationLegendSlide } from './overview.models';
import { BehaviorSubject } from 'rxjs';
//   
import { selectPerformanceTypeFilter } from '../performance/performance.selectors';
import { SetPerformanceTypeFilterAction } from '../performance/performance.actions';
import { DecimalService } from '../../global/pipes/decimal.pipe';
// import { MosSlideToggleChange } from 'merceros-ui-components/lib/components/form-controls/slide-toggle/slide-toggle.component';
import { WindowResizeService } from '../../global/window-resize.service';
import { sortBy, isEqual } from 'lodash';
import { OVERVIEW_PERFORMANCE_COMMON_HEADERS, PERFORMANCE_COMMON_HEADERS } from '../performance/performance.models';
import { environment } from '../../../environments/environment';
import { TableColumnAlignment } from 'atlas-table';
import { PaginationInfo } from 'atlas-pagination';
import { DropdownPlacement, DropdownTriggerType } from 'atlas-menu';

@Component({
  standalone: false,
  selector: 'dsp-overview',
  templateUrl: 'overview.container.html',
  styleUrls: ['overview.container.scss']
})
export class OverviewContainerComponent implements OnInit, OnDestroy {
  public env = environment;
  public dropdownTriggerTypeCustom = DropdownTriggerType.Custom;
  dropdownTriggerTypeIconButton = DropdownTriggerType.IconButton;
  dropdownPlacementLeftStart = DropdownPlacement.LeftStart;

  public performanceHeaders: ColumnDef[] = [
    {
      name: '',
      column: 'action',
      displayLabel: '',
      fieldKey: 'action',
      sortable: false
    },
    {
      name: 'Name',
      column: 'name',
      displayLabel: 'Name',
      fieldKey: 'name',
      sortable: false
    },
    {
      name: 'Closing Balance ($)*',
      column: 'closing',
      align: TableColumnAlignment.right,
      displayLabel: 'Closing Balance ($)*',
      fieldKey: 'closing',
      sortable: false
    },
  ];

  public loading$: Observable<boolean>;
  public currency$: Observable<string>;
  public showPortfolioValuation$: Observable<boolean>;
  public portfolioValuationDate$: Observable<string>;
  public portfolioValuationValue$: Observable<any>;
  public showInvestmentGrowth$: Observable<boolean>;
  public investmentGrowthDate$: Observable<string>;
  public investmentGrowthChart$: Observable<Chart>;
  public showAssetAllocation$: Observable<boolean>;
  public assetAllocationDate$: Observable<string>;
  public assetAllocationChart$: Observable<Chart>;
  public assetAllocationLegend$: Observable<AllocationLegendSlide[][]>;
  public assetAllocationLegendPage$: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  public assetAllocationLegendTotal$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public showPerformanceValuation$: Observable<boolean>;
  public performanceValuationDate$: Observable<string>;
  public performanceValuationHoldingDate$: Observable<string>;
  public performanceValuationTable$: Observable<any>;
  public performanceValuationPagination$: Observable<PaginationInfo>;

  public performanceValuationType$: Observable<'gross' | 'net'>;
  public performanceValuationHeaders$: Observable<ColumnDef[]>;
  public performanceValuationExpandedRows$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  public performanceValuationRowsExpanded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public notes$: BehaviorSubject<PageNotes> = new BehaviorSubject<PageNotes>({} as PageNotes);
  // public user$: Observable<User | undefined>;
  private readonly subscription: Subscription = new Subscription();
  public ShowClientPerfromance = false;
  public selectedCountry = '';
  public micLegend$: Observable<[][]>;
  public micLegendPage$: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  public micLegendTotal$: BehaviorSubject<number> = new BehaviorSubject<number>(0);



  public constructor(
    // private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly decimal: DecimalService,
    private readonly resize: WindowResizeService
  ) {
    // this.user$ = this.store.pipe(select(selectAuthUser));
    this.performanceHeaders = this.performanceHeaders.concat(OVERVIEW_PERFORMANCE_COMMON_HEADERS);
    this.loading$ = this.selectLoading();
    this.currency$ = this.selectCurrency();
    this.showPortfolioValuation$ = this.selectShowPortfolioValuation();
    this.portfolioValuationDate$ = this.selectPortfolioValuationDate();
    this.portfolioValuationValue$ = this.selectPortfolioValuationValue();
    this.showInvestmentGrowth$ = this.selectShowInvestmentGrowth();
    this.investmentGrowthDate$ = this.selectInvestmentGrowthDate();
    this.investmentGrowthChart$ = this.selectInvestmentGrowthChart();
    this.showAssetAllocation$ = this.selectShowAssetAllocation();
    this.assetAllocationDate$ = this.selectAssetAllocationDate();
    this.assetAllocationChart$ = this.selectAssetAllocationChart();
    this.assetAllocationLegend$ = this.selectAssetAllocationLegend();
    this.showPerformanceValuation$ = this.selectShowPerformanceValuation();
    this.performanceValuationDate$ = this.selectPerformanceValuationDate();
    this.performanceValuationHoldingDate$ = this.selectPerformanceValuationHoldingDate();
    this.performanceValuationTable$ = this.selectPerformanceValuationTable();
    this.performanceValuationPagination$ = this.selectPerformanceValuationPagination();
    this.performanceValuationType$ = this.selectPerformanceValuationType();
    this.performanceValuationHeaders$ = this.selectPerformanceValuationHeaders();
    this.micLegend$ = this.selectMicLegend();


  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeLoadWidgetData());
    this.subscription.add(this.subscribeNotes());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.selectedCountry = country;
    });
  }

  public onClickFundRow(fund: string, event?: any): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.store.pipe(
      select(selectPerformanceValuationData),
      map(data => data.funds),
      take(1)
    ).subscribe(funds => {
      const rows = this.performanceValuationExpandedRows$.value,
        index = rows.indexOf(fund);

      if (index < 0) {
        this.performanceValuationExpandedRows$.next([...rows, fund]);
      } else {
        rows.splice(index, 1);
        this.performanceValuationExpandedRows$.next(rows);
      }
      // const tableRowsCount = (environment.APP_ENV === 'QA' || environment.APP_ENV === 'development')
      //   ? funds.length + 1 : funds.length;
      const tableRowsCount = funds.length + 1;

      if (this.performanceValuationExpandedRows$.value.length === tableRowsCount) {
        this.performanceValuationRowsExpanded$.next(true);
      } else if ((this.performanceValuationExpandedRows$.value.length !== tableRowsCount) ||
        !this.performanceValuationExpandedRows$.value.length) {
        this.performanceValuationRowsExpanded$.next(false);
      }
    });
  }

  public onChangePerformanceType(): void {
    this.store.dispatch(new SetPerformanceTypeFilterAction());
  }

  // public onToggleRows(event: MosSlideToggleChange): void {
  //   this.store.pipe(
  //     select(selectPerformanceValuationData),
  //     filter(data => !!data),
  //     map(data => data.funds.map((fund: any) => fund._id)),
  //     take(1)
  //   ).subscribe(funds => {
  //     // const tableRowsCount = (environment.APP_ENV === 'QA' || environment.APP_ENV === 'development')
  //     //   ? funds.length + 1 : funds.length;
  //     const tableRowsCount = funds.length + 1;
  //     if (this.performanceValuationExpandedRows$.value.length === tableRowsCount || !event.checked) {
  //       this.performanceValuationExpandedRows$.next([]);
  //     } else {
  //       this.performanceValuationExpandedRows$.next([...funds, 'total']);
  //     }

  //     this.performanceValuationRowsExpanded$.next(event.checked);
  //   });
  // }


  public onToggleRows(event: boolean): void {
    this.store.pipe(
      select(selectPerformanceValuationData),
      filter(data => !!data),
      map(data => data.funds.map((fund: any) => fund._id)),
      take(1)
    ).subscribe(funds => {
      // const tableRowsCount = (environment.APP_ENV === 'QA' || environment.APP_ENV === 'development')
      //   ? funds.length + 1 : funds.length;
      const tableRowsCount = funds.length + 1;
      if (this.performanceValuationExpandedRows$.value.length === tableRowsCount || !event) {
        this.performanceValuationExpandedRows$.next([]);
      } else {
        this.performanceValuationExpandedRows$.next([...funds, 'total']);
      }

      this.performanceValuationRowsExpanded$.next(event);
    });
  }

  public onLegendSlide(event: number): void {
    this.assetAllocationLegendPage$.next(event + 1);
  }
  public onMicLegendSlide(event: number): void {
    this.micLegendPage$.next(event + 1);
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectOverviewLoading),
    );
  }

  private selectCurrency(): Observable<string> {
    return this.store.pipe(
      select(selectMainFilterSelectedClient),
      filter(client => !!client),
      map(client => getCurrencyByCountry(client.country))
    );
  }

  private selectShowPortfolioValuation(): Observable<boolean> {
    return this.store.pipe(
      select(selectPortfolioValuation),
      map(data => !!data)
    );
  }

  private selectPortfolioValuationDate(): Observable<string> {
    return this.store.pipe(
      select(selectPortfolioValuationDate),
      filter(date => !!date),
      map(date => formatDate(date, 'DD/MM/YYYY'))
    );
  }

  private selectPortfolioValuationValue(): Observable<any> {
    return this.store.pipe(
      select(selectPortfolioValuationValue),
      filter(value => !!value),
      map(value => value)
    );
  }

  private selectShowInvestmentGrowth(): Observable<boolean> {
    return this.store.pipe(
      select(selectInvestmentGrowth),
      map(data => !!data)
    );
  }

  private selectInvestmentGrowthDate(): Observable<string> {
    return this.store.pipe(
      select(selectInvestmentGrowthDate),
      filter(date => !!date),
      map(date => formatDate(date, 'DD/MM/YYYY'))
    );
  }

  private selectInvestmentGrowthChart(): Observable<Chart> {
    return this.store.pipe(
      select(selectInvestmentGrowthData),
      filter(data => !!data && !!data.length),
      withLatestFrom(this.currency$),
      distinctUntilChanged(isEqual),
      map(([data, currency]) => {
        const pipe = this.decimal;

        let chartData = data.map((item) =>
          [moment.utc(item.date).valueOf(), +item.redPrice]
        );

        chartData = sortBy(chartData, item => item[0]);

        return new Chart({
          chart: {
            height: 330,
            style: {
              fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
            },
          },
          credits: {
            enabled: false
          },
          title: {
            style: {
              display: 'none'
            }
          },
          exporting: {
            enabled: false
          },
          plotOptions: {
            line: {
              marker: {
                enabled: false
              },
              states: {
                hover: {
                  enabled: false
                }
              }
            }
          },
          tooltip: {
            enabled: true,
            useHTML: true,
            formatter(): string {
              return `
                <span style="display: block; font-size: 10px">${moment.utc(this.x).format('dddd, MMM  D YYYY')}</span>
                <span style="color: ${this.color}">●</span>
                <span>${this.series.name}:</span>
                <span style="font-weight: bold">$ ${pipe.transform(data.find(item => +item.redPrice === this.y).redPrice)}</span>
              `;
            }
          },
          legend: {
            enabled: false
          },
          yAxis: {
            title: {
              text: `Investments ${currency} $`
            }
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              day: '%Y-%m-%e'
            },
          },
          series: [
            {
              name: 'Total Portfolio',
              color: '#0FB694',
              data: chartData
            }
          ]
        } as any);
      })
    );
  }

  private selectShowAssetAllocation(): Observable<boolean> {
    return this.store.pipe(
      select(selectAssetAllocationData),
      map(data => !!data)
    );
  }

  private selectAssetAllocationDate(): Observable<string> {
    return this.store.pipe(
      select(selectAssetAllocationDate),
      filter(date => !!date),
      map(date => formatDate(date, 'MMM YYYY'))
    );
  }

  private selectAssetAllocationChart(): Observable<Chart> {
    return this.store.pipe(
      select(selectAssetAllocationData),
      filter(data => !!data),
      distinctUntilChanged(isEqual),
      map(data => {
        const pipe = this.decimal,

          chartData = data.map((item: { name: string; allocation: string }, index: number) => {
            const color = RGB_COLORS[index];

            return {
              name: item.name,
              y: parseFloat(item.allocation),
              color: `rgba(${color.r}, ${color.g}, ${color.b}, 1)`
            };
          });

        return new Chart({
          chart: {
            plotShadow: false,
            height: 300,
            type: 'pie',
            style: {
              fontFamily: '"proxima_nova_regular", "Helvetica", "Arial", "sans-serif"',
            },
          },
          credits: {
            enabled: false
          },
          title: {
            style: {
              display: 'none'
            }
          },
          exporting: {
            enabled: false
          },
          tooltip: {
            enabled: true,
            useHTML: true,
            formatter(): string {
              return `
                <span style="display: block; font-size: 10px">${this.key}</span>
                <span style="color: ${this.color}">●</span>
                <span>${this.series.name}:</span>
                <span style="font-weight: bold">${pipe.transform(data.find(item => +item.allocation === this.y).allocation)}%</span>
              `;
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              dataLabels: {
                enabled: false,
              },
              states: {
                hover: {
                  enabled: false
                }
              },
            },
          },
          series: [
            {
              name: 'Asset Allocation',
              colorByPoint: true,
              size: '80%',
              innerSize: '65%',
              data: chartData
            }
          ]
        } as any);
      })
    );
  }

  private selectAssetAllocationLegend(): Observable<AllocationLegendSlide[][]> {
    return this.store.pipe(
      select(selectAssetAllocationData),
      filter(data => !!data),
      distinctUntilChanged(isEqual),
      map((data: { name: string; allocation: string }[]) =>
        data.map((item, index: number) => ({ ...item, color: RGB_COLORS[index].id }))
      ),
      map(data => {
        const slides = [];

        for (let i = 0; i <= data.length; i += 2) {
          const slice = data.slice(i, i + 2);
          if (!!slice.length) {
            slides.push(slice);
          }
        }
        this.assetAllocationLegendPage$.next(1);
        return slides;
      }),
      tap(slides => this.assetAllocationLegendTotal$.next(slides.length))
    );
  }

  public selectMicLegend(): Observable<[][]> {
    return this.store.pipe(
      select(selectMicData),
      filter(data => !!data),
      distinctUntilChanged(isEqual),
      map(data => {
        const slides = [];
        for (let i = 0; i <= data.data.length; i++) {
          const slice = data.data.slice(i, i + 1);
          if (!!slice.length) {
            slides.push(slice);
          }
        }
        this.micLegendPage$.next(1);
        return slides;
      }),
      tap(slides => this.micLegendTotal$.next(slides.length))
    );
  }


  private selectShowPerformanceValuation(): Observable<boolean> {
    return this.store.pipe(
      select(selectPerformanceValuationAvailability),
      map(data => !!data)
    );
  }

  private selectPerformanceValuationDate(): Observable<string> {
    return this.store.pipe(
      select(selectPerformanceValuationDate),
      filter(date => !!date),
      map(date => formatDate(date, 'MMM YYYY'))
    );
  }

  private selectPerformanceValuationHoldingDate(): Observable<string> {
    return this.store.pipe(
      select(selectPerformanceValuationHoldingDate),
      filter(holdingDate => !!holdingDate),
      map(holdingDate => formatDate(holdingDate, 'DD/MM/YYYY'))
    );
  }

  private selectPerformanceValuationTable(): Observable<any> {
    // return combineLatest(
    //   this.store.pipe(
    //     select(selectPerformanceValuationData),
    //     filter(data => !!data)
    //   ),
    //   this.store.pipe(select(selectPerformanceTypeFilter)),
    //   this.performanceValuationExpandedRows$
    // ).pipe(
    return combineLatest([
      this.store.pipe(
        select(selectPerformanceValuationData),
        filter(data => !!data)
      ),
      this.store.pipe(select(selectPerformanceTypeFilter)),
      this.performanceValuationExpandedRows$
    ]).pipe(
      map(([data, type, expanded]) => {
        const rows = [],
          // TO DO : Overview Page

          // const expand = (environment.APP_ENV === 'QA' || environment.APP_ENV === 'development')
          //   ? expanded.includes(`total`) : false;
          // const expand = false;
          // expanded.includes(`total`);
          expand = (data.total.isClientPerfDataAvailable === 'true') ? expanded.includes(`total`) : false;
        // this.ShowClientPerfromance = (environment.APP_ENV === 'QA' || environment.APP_ENV === 'development')
        //   ? true : false;
        // this.ShowClientPerfromance = true;
        this.ShowClientPerfromance = (data.total.isClientPerfDataAvailable === 'true') ? true : false;
        rows.push({
          _id: `total`,
          name: 'Total Portfolio',
          closing: data.total.closing,
          expanded: expand,
          '1m': data.total['1m'][type],
          '3m': data.total['3m'][type],
          CYTD: data.total['CYTD'][type],
          FYTD: data.total['FYTD'][type],
          MTD: data.total['MTD'][type],
          '1y': data.total['1y'][type],
          '3y': data.total['3y'][type],
          '5y': data.total['5y'][type],
          '7y': data.total['7y'][type],
          '10y': data.total['10y'][type],
        });

        rows.push({
          parent: `total`,
          name: 'Benchmark',
          tooltip: `Benchmark`,
          expanded: expand,
          '1m': data.total['1m']['benchmark'],
          '3m': data.total['3m']['benchmark'],
          CYTD: data.total['CYTD']['benchmark'],
          FYTD: data.total['FYTD']['benchmark'],
          MTD: data.total['MTD']['benchmark'],
          '1y': data.total['1y']['benchmark'],
          '3y': data.total['3y']['benchmark'],
          '5y': data.total['5y']['benchmark'],
          '7y': data.total['7y']['benchmark'],
          '10y': data.total['10y']['benchmark'],
        });
        rows.push({
          parent: `total`,
          name: 'Excess Returns',
          expanded: expand,
          '1m': data.total['1m'][`${type}Excess`],
          '3m': data.total['3m'][`${type}Excess`],
          CYTD: data.total['CYTD'][`${type}Excess`],
          FYTD: data.total['FYTD'][`${type}Excess`],
          MTD: data.total['MTD'][`${type}Excess`],
          '1y': data.total['1y'][`${type}Excess`],
          '3y': data.total['3y'][`${type}Excess`],
          '5y': data.total['5y'][`${type}Excess`],
          '7y': data.total['7y'][`${type}Excess`],
          '10y': data.total['10y'][`${type}Excess`],
        });
        data.funds.forEach((fund: any) => {
          const expand = expanded.includes(fund._id);

          rows.push({
            _id: fund._id,
            name: fund.name,
            closing: fund.closing,
            expanded: expand,
            '1m': fund['1m'][type],
            '3m': fund['3m'][type],
            CYTD: fund['CYTD'][type],
            FYTD: fund['FYTD'][type],
            MTD: fund['MTD'][type],
            '1y': fund['1y'][type],
            '3y': fund['3y'][type],
            '5y': fund['5y'][type],
            '7y': fund['7y'][type],
            '10y': fund['10y'][type],
          });

          rows.push({
            parent: fund._id,
            name: 'Benchmark',
            tooltip: fund.benchmarkName !== undefined ? fund.benchmarkName : '',
            expanded: expand,
            '1m': fund['1m']['benchmark'],
            '3m': fund['3m']['benchmark'],
            CYTD: fund['CYTD']['benchmark'],
            FYTD: fund['FYTD']['benchmark'],
            MTD: fund['MTD']['benchmark'],
            '1y': fund['1y']['benchmark'],
            '3y': fund['3y']['benchmark'],
            '5y': fund['5y']['benchmark'],
            '7y': fund['7y']['benchmark'],
            '10y': fund['10y']['benchmark'],
          });

          rows.push({
            parent: fund._id,
            name: 'Excess Returns',
            expanded: expand,
            '1m': fund['1m'][`${type}Excess`],
            '3m': fund['3m'][`${type}Excess`],
            CYTD: fund['CYTD'][`${type}Excess`],
            FYTD: fund['FYTD'][`${type}Excess`],
            MTD: fund['MTD'][`${type}Excess`],
            '1y': fund['1y'][`${type}Excess`],
            '3y': fund['3y'][`${type}Excess`],
            '5y': fund['5y'][`${type}Excess`],
            '7y': fund['7y'][`${type}Excess`],
            '10y': fund['10y'][`${type}Excess`],
          });
        });

        return rows;
      })
    );
  }

  private selectPerformanceValuationPagination(): Observable<PaginationInfo> {
    return this.store.pipe(
      select(selectPerformanceValuationFunds),
      map(funds => ({
        page: 1,
        itemsByPage: funds.length,
        total: funds.length
      }))
    );
  }

  private selectPerformanceValuationType(): Observable<'gross' | 'net'> {
    return this.store.pipe(
      select(selectPerformanceTypeFilter)
    );
  }

  // private selectPerformanceValuationHeaders(): Observable<TableHeader[]> {
  //   return this.isMobile$.pipe(
  //     map(isMobile => {
  //       if (isMobile) {
  //         const mobileColumns = ['name', 'closing'];

  //         return this.performanceHeaders.filter(header => mobileColumns.includes(header.column));
  //       } else {
  //         return this.performanceHeaders.concat([
  //           {
  //           name: 'MTD (%)',
  //           column: 'MTD',
  //           textAlign: 'right',
  //           icon: 'info_outline',
  //           tooltip: 'MTD (Month To Date) calculated utilizing the latest available and the last month end Net Asset Unit Price.'
  //         }
  //       ]);
  //       }
  //     })
  //   );
  // }


  private selectPerformanceValuationHeaders(): Observable<ColumnDef[]> {
    return this.isMobile$.pipe(
      map(isMobile => {
        if (isMobile) {
          const mobileColumns = ['name', 'closing'];

          return this.performanceHeaders.filter(header => mobileColumns.includes(header.column));
        } else {
          return this.performanceHeaders.concat([
            {
              name: 'MTD (%)',
              displayLabel: 'MTD (%)',
              fieldKey: 'MTD',
              column: 'MTD',
              align: TableColumnAlignment.right,
              icon: 'c-info',
              collection: 'user-interface',
              size: 'small',
              sortable: false,
              tooltip: 'MTD (Month To Date) calculated utilizing the latest available and the last month end Net Asset Unit Price.'
            }
          ]);
        }
      })
    );
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private subscribeLoadWidgetData(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount),
      distinctUntilChanged(isEqual)
    ).subscribe(account => {
      if (!!account) {
        this.performanceValuationRowsExpanded$.next(false);
        this.performanceValuationExpandedRows$.next([]);
        this.store.dispatch(new LoadWidgetsDataAction({ account: account._id, country: this.selectedCountry }));
      } else {
        this.store.dispatch(new ResetWidgetsDataAction());
      }
    });
  }

  private subscribeNotes(): Subscription {
    return this.store.pipe(
      select(selectMainPageNotes)
    ).subscribe(this.notes$);
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
